<template>
  <div class="card card-user card-news-box">
    <div class="image">
      <img v-if="news.image" :src="`/api/image/${news.image}`" onerror="this.src = '/static/img/placeholder.png'" alt="news image">
      <img v-else src="/static/img/placeholder.png">
    </div>
    <div class="card-body">
      <div class="text-left">
        <router-link tag="a" :to="{ name: 'NewsDetails', params: { id: news._id } }">
          <h5 class="text-truncate text-info">{{ news.title }}</h5>
        </router-link>
      </div>
      <div class="truncate-wrapper">
        <p class="description text-left" v-html="news.content">
        </p>
      </div>
    </div>
    <hr>
    <div class="card-footer">
      <div class="button-container">
        <div class="row">
          <div class="col-sm-12">
            <div class="pull-left">
              <i class="icon" :class="newsIcons[news.type]"/>
            </div>
            <div class="pull-right" v-if="!news.link">
              {{ $t('more') }} &nbsp;
              <p-button aria-label="view button" type="primary" round icon size="sm" @click="() => $router.push({ name: 'NewsDetails', params: { id: news._id } })">
                <i class="nc-icon nc-minimal-right"/>
              </p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button } from 'src/components/UIComponents'
  import { newsIcons } from '../../../util/icons'

  export default {
    name: 'NewsBox',
    components: {
      [Button.name]: Button
    },
    props: {
      news: {
        title: String,
        image: String,
        text: String,
        link: String
      }
    },
    data () {
      return {
        newsIcons
      }
    }
  }
</script>
<style lang="scss" scoped>
  .card-news-box {
    --max-lines: 6;
    --lh: 1.5em;
    height: calc(100% - 20px);

    .card-body {
      min-height: calc(var(--lh) * var(--max-lines));
      line-height: var(--lh);
    }
    .icon {
      color: grey;
    }
    .image img {
      height: 130px;
      width: 100%;
      object-fit: cover;
      border-radius: 12px 12px 0 0;
    }
    .truncate-wrapper {
      overflow: hidden;
      position: relative;
      max-height: calc(var(--lh) * var(--max-lines));
      word-break: break-word;
      white-space: pre-wrap;
    }
    .truncate-wrapper::after {
      content: "";
      position: absolute;
      top: calc((var(--lh) * var(--max-lines)) - var(--lh));
      right: 0;
      height: var(--lh);
      width: 80%;
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, white 50%);
    }
    p {
      padding: 0;
      margin: 0;
    }

    .text-truncate {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      white-space: normal;
    }
  }
</style>